import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {TaskModel} from '@/models/task.model';
import {TaskApi} from '@/api/task.api';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';
import {PaginatedParams} from '@/api/base.api';

export const featureKey = 'tasks';

// @ts-ignore
if (store.state.tasks) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class TasksStoreModule extends EntityStateAdapter<TaskModel> {

  get tasks(): TaskModel[] {
    return this._entities;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchTasks(data: { challengeId: number, pageParams: PaginatedParams }): Promise<TaskModel[]> {
    this.updateLoading(true);
    const response = await new TaskApi(data.challengeId)
      .allPaginated(data.pageParams)
      .pipe(take(1))
      .toPromise();
    this.updatePageParams(response);
    return response.data
  }

  @Action({commit: 'upsertOne', rawError: true})
  async updateTask(data: { challengeId: number, task: TaskModel }): Promise<TaskModel> {
    return await new TaskApi(data.challengeId).update(data.task).pipe(take(1)).toPromise();
  }

  @Action({commit: 'upsertOne', rawError: true})
  async acceptTask(data: { challengeId: number, taskId: number }): Promise<TaskModel> {
    return await new TaskApi(data.challengeId).join(data.taskId).pipe(take(1)).toPromise()
  }

  @Action({commit: 'upsertOne', rawError: true})
  async abortTask(data: { challengeId: number, taskId: number }): Promise<TaskModel> {
    return await new TaskApi(data.challengeId).abort(data.taskId).pipe(take(1)).toPromise()
  }
}
